interface SessionCredentials {
  firebaseToken: string;
  installationReference: string;
  sessionId: string;
}

const installationKey = "cyra.installation-reference";
const sessionKey = "cyra.session-id";
let tokenReader: (() => Promise<string | null>) | null = null;

function installationReference(): string {
  const existing = window.localStorage.getItem(installationKey);
  if (existing) return existing;
  const value = `${crypto.randomUUID()}${crypto.randomUUID()}`;
  window.localStorage.setItem(installationKey, value);
  return value;
}

export function registerTokenReader(reader: () => Promise<string | null>): void {
  tokenReader = reader;
}

export function setCyraSession(sessionId: string): void {
  window.localStorage.setItem(sessionKey, sessionId);
}

export function clearCyraSession(): void {
  window.localStorage.removeItem(sessionKey);
}

export function currentCyraSessionId(): string | null {
  return window.localStorage.getItem(sessionKey);
}

export async function readSessionCredentials(): Promise<SessionCredentials | null> {
  const sessionId = currentCyraSessionId();
  if (!sessionId) return null;
  const firebaseToken = await tokenReader?.();
  if (sessionId !== currentCyraSessionId())
    throw new DOMException("Session changed during credential lookup.", "AbortError");
  if (!firebaseToken) return null;
  return { firebaseToken, installationReference: installationReference(), sessionId };
}

export function getInstallationReference(): string {
  return installationReference();
}
